import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { xBaseTheme } from "@stoneage/XDL/types";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        iconProps: {
            size: 8,
        },
        typographyProps: {
            size: 10,
            weight: "bold",
        },
        css: css`
            gap: 12px;
            padding: 4px 12px 4px 8px;
            align-items: center;
            min-height: unset;
            max-height: unset;
            border-radius: unset;
            background-color: ${color("common.ui7")};
            && button {
                background-color: unset;
                min-height: unset;
                width: 8px;
                height: 8px;
                margin-top: 2px;
                & :hover {
                    background-color: unset;
                }
                & :focus {
                    background-color: ${color("common.ui7")};
                }
            }
        `,
    },
} as xBaseTheme["tag"];
